//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import defaultTablePagerTemplate from '@partials/default-table-pager.html';
import defaultTablePageDropdownTemplate from '@partials/default-table-page-dropdown.html';
import tablePaginationTemplate from '@partials/table-pagination.html';

// This directive is meant to override the default pagination style from ngTables.
//
// Note: Because ngTables includes default pagination, this directive must be applied
// by attaching the 'template-pagination'="/partials/pagination-wrapper.html" to the <table>
// rather than attaching an attribute or class directly to the element.
// Also, if you are overriding the ngTable getData function, you must reset the total and
// reload the table for pagination to appear properly.

(function() {
  angular.module('curalate').run(['$templateCache', ($templateCache) => {
    $templateCache.put('/partials/default-table-pager.html', defaultTablePagerTemplate);
    $templateCache.put('/partials/default-table-page-dropdown.html', defaultTablePageDropdownTemplate);
  }]);

  angular.module('curalate').directive('tablePagination', () => ({
    restrict: 'C',
    template: tablePaginationTemplate,
    transclude: false,
    controller: ['$scope',
      function($scope) {
                    // Functionality for the 'Go to page __ of <total>' pagination element
        $scope.toPage = function(page) {
          if (page > 0 && page <= $scope.numPages) {
            $scope.params.page(page);
          }
        };
      },
    ],
  }));
})();
